// ไฟล์: frontend/src/pages/HomePage.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./HomePage.css";

const HomePage = ({ user }) => {
  const [stats, setStats] = useState({
    users: 0,
    resources: 0,
    innovations: 0,
    articles: 0,
  });
  const [popularResources, setPopularResources] = useState([]);
  const [topTeachers, setTopTeachers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axios.get("/dashboard");
        setStats(response.data.counts);
        setPopularResources(response.data.popularResources);
        setTopTeachers(response.data.topTeachers);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  // แสดงสถานะการโหลด
  if (loading) {
    return (
      <div className="loading-container">
        {/* <div className="loading-spinner">กำลังโหลดข้อมูล...</div> */}
      </div>
    );
  }

  return (
    <div className="home-page">
      {/* Hero Section */}

      <section
        className="hero-section position-relative text-white d-flex align-items-center"
        style={{
          backgroundImage:
            "url('https://itbrief.com.au/uploads/story/2024/06/24/techday_3aff3fa72fafedec9d26.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "45vh",
        }}
      >
        {/* ม่านดำแบบบาง */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}
        ></div>

        <div className="container position-relative z-2 text-center">
          <h1 className="display-4 fw-bold mb-4">
            แบ่งปัน เรียนรู้ พัฒนา{" "}
            <span className="text-warning">ไปด้วยกัน</span>
          </h1>
          <p className="lead mb-5">
            ศูนย์กลางการแบ่งปันความรู้ สื่อการสอน และนวัตกรรมสำหรับครูทั่วประเทศ
            ร่วมสร้างสังคมแห่งการเรียนรู้และพัฒนาวิชาชีพครูไปพร้อมกัน
          </p>

          {!user ? (
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <Link to="/register" className="btn btn-primary btn-lg">
                <i className="fas fa-user-plus"></i> สมัครสมาชิกฟรี
              </Link>
              <Link to="/resources" className="btn btn-light btn-lg">
                <i className="fas fa-search"></i> ค้นหาสื่อการสอน
              </Link>
            </div>
          ) : (
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <Link to="/upload-resource" className="btn btn-primary btn-lg">
                <i className="fas fa-upload"></i> อัปโหลดสื่อการสอน
              </Link>
              <Link to="/resources" className="btn btn-light btn-lg">
                <i className="fas fa-search"></i> ค้นหาสื่อการสอน
              </Link>
            </div>
          )}
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">
                <i className="fas fa-users"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.users}</div>
                <div className="stat-label">ครูในระบบ</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <i className="fas fa-book"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.resources}</div>
                <div className="stat-label">สื่อการสอน</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <i className="fas fa-lightbulb"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.innovations}</div>
                <div className="stat-label">นวัตกรรม</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <i className="fas fa-pen-fancy"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.articles}</div>
                <div className="stat-label">บทความ</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <div className="section-header">
            <h2>ฟีเจอร์หลักของระบบ</h2>
            <p>
              เครื่องมือที่ช่วยให้ครูแบ่งปันและเรียนรู้ได้อย่างมีประสิทธิภาพ
            </p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-book"></i>
              </div>
              <h3>คลังสื่อการสอน</h3>
              <p>
                รวบรวมสื่อการสอนคุณภาพจากครูทั่วประเทศ แบ่งตามวิชา ระดับชั้น
                และประเภท
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-lightbulb"></i>
              </div>
              <h3>นวัตกรรม / แนวปฏิบัติที่ดี</h3>
              <p>
                แบ่งปันนวัตกรรมและแนวปฏิบัติที่ดีจากครูต้นแบบเพื่อต่อยอดการเรียนการสอน
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-newspaper"></i>
              </div>
              <h3>ข่าวสารการศึกษา</h3>
              <p>
                อัพเดทข่าวสารการศึกษา การอบรม ประชุม นโยบาย และทุนการศึกษาต่างๆ
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-pen-fancy"></i>
              </div>
              <h3>บทความ / แนวคิด</h3>
              <p>แลกเปลี่ยนแนวคิด มุมมอง และประสบการณ์ในการจัดการเรียนการสอน</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-upload"></i>
              </div>
              <h3>อัปโหลดสื่อ</h3>
              <p>แบ่งปันสื่อการสอนของคุณให้กับเพื่อนครูทั่วประเทศได้ง่ายๆ</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-bookmark"></i>
              </div>
              <h3>คลังความรู้ส่วนตัว</h3>
              <p>
                บันทึกสื่อและเนื้อหาที่สนใจไว้ในคลังส่วนตัว จัดหมวดหมู่
                และเข้าถึงได้ทุกที่
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-star"></i>
              </div>
              <h3>ให้คะแนนเนื้อหา</h3>
              <p>
                ให้คะแนนและแสดงความคิดเห็นต่อสื่อการสอนและนวัตกรรมที่มีคุณภาพ
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-trophy"></i>
              </div>
              <h3>ระบบ Badges / Ranking</h3>
              <p>
                รับเหรียญรางวัลและอันดับสำหรับครูผู้แบ่งปันที่มีคุณภาพและได้รับความนิยม
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Popular Resources Section */}
      <section className="popular-section">
        <div className="container">
          <div className="section-header">
            <h2>สื่อการสอนยอดนิยม</h2>
            <p>สื่อการสอนที่ได้รับความนิยมและถูกดาวน์โหลดมากที่สุด</p>
          </div>
          <div className="resources-grid">
            {popularResources.map((resource) => (
              <div className="resource-card" key={resource.id}>
                <div className="resource-thumbnail">
                  <img
                    src={
                      resource.thumbnail
                        ? `${process.env.REACT_APP_API_URL}/uploads/${resource.thumbnail}`
                        : "/assets/default-resource.jpg"
                    }
                    alt={resource.title}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `https://via.placeholder.com/300x200?text=${encodeURIComponent(
                        resource.title || "สื่อการสอน"
                      )}`;
                    }}
                  />
                  <span className="resource-type">
                    {resource.file_type === "pdf" ? (
                      <i className="fas fa-file-pdf"></i>
                    ) : resource.file_type === "ppt" ? (
                      <i className="fas fa-file-powerpoint"></i>
                    ) : resource.file_type === "video" ? (
                      <i className="fas fa-video"></i>
                    ) : resource.file_type === "link" ? (
                      <i className="fas fa-link"></i>
                    ) : resource.file_type === "drive" ? (
                      <i className="fab fa-google-drive"></i>
                    ) : (
                      <i className="fas fa-link"></i> // default
                    )}{" "}
                    {resource.file_type}
                  </span>
                </div>
                <div className="resource-content">
                  <h3 className="resource-title">
                    <Link to={`/resources/${resource.id}`}>
                      {resource.title}
                    </Link>
                  </h3>
                  <div className="resource-description">
                    {resource.description?.length > 100
                      ? `${resource.description.substring(0, 100)}...`
                      : resource.description}
                  </div>
                  <div className="resource-meta">
                    <div className="resource-author">
                      <img
                        src={`https://ui-avatars.com/api/?name=${resource.author_name}&background=random`}
                        alt={resource.author_name}
                      />
                      <span>{resource.author_name}</span>
                    </div>
                    <div className="resource-stats">
                      <div className="resource-views">
                        <i className="fas fa-eye"></i> {resource.view_count}
                      </div>
                      <div className="resource-downloads">
                        <i className="fas fa-download"></i>{" "}
                        {resource.download_count}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="resource-footer">
                  <div className="resource-rating">
                    <div className="rating">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i
                          key={star}
                          className={`fas fa-star ${
                            star <= Math.round(resource.avg_rating || 0)
                              ? "filled"
                              : ""
                          }`}
                        ></i>
                      ))}
                      <span className="rating-value">
                        {resource.avg_rating !== undefined &&
                        resource.avg_rating !== null &&
                        !isNaN(Number(resource.avg_rating))
                          ? Number(resource.avg_rating).toFixed(1)
                          : "0.0"}
                      </span>{" "}
                    </div>
                  </div>
                  <Link
                    to={`/resources/${resource.id}`}
                    className="btn btn-sm btn-primary"
                  >
                    <i className="fas fa-info-circle"></i> รายละเอียด
                  </Link>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <Link to="/resources" className="btn btn-primary">
              <i className="fas fa-search"></i> ดูสื่อการสอนทั้งหมด
            </Link>
          </div>
        </div>
      </section>

      {/* Top Teachers Section */}
      <section className="teachers-section">
        <div className="container">
          <div className="section-header">
            <h2>ครูผู้แบ่งปันยอดเยี่ยม</h2>
            <p>
              ครูที่มีผลงานการแบ่งปันสื่อการสอน นวัตกรรม และบทความที่มีคุณภาพ
            </p>
          </div>
          <div className="teachers-grid">
            {topTeachers.map((teacher) => (
              <div className="teacher-card" key={teacher.id}>
                <div className="teacher-avatar">
                  {/* <img
                    src={
                      teacher.profile_image
                        ? `${process.env.REACT_APP_API_URL}/uploads/profiles/${teacher.profile_image}`
                        : `https://ui-avatars.com/api/?name=${teacher.fullname}&background=random&size=200`
                    }
                    alt={teacher.fullname}
                  /> */}
                  
                  <img
                    src={
                      teacher.profile_image
                        ? `${process.env.REACT_APP_API_URL}/uploads/profiles/${teacher.profile_image}`
                        : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                            teacher.fullname
                          )}&background=random&size=200&color=fff`
                    }
                    alt={teacher.fullname}
                  />
                </div>
                <div className="teacher-info">
                  <h3 className="teacher-name">
                    <Link to={`/teachers/${teacher.id}`}>
                      {teacher.fullname}
                    </Link>
                  </h3>
                  <div className="teacher-school">{teacher.school}</div>
                  <div className="teacher-stats">
                    <div className="teacher-stat">
                      <i className="fas fa-file-alt"></i>{" "}
                      {teacher.content_count} ผลงาน
                    </div>
                    <div className="teacher-stat">
                      <i className="fas fa-users"></i> {teacher.follower_count}{" "}
                      ผู้ติดตาม
                    </div>
                  </div>
                  <Link
                    to={`/teachers/${teacher.id}`}
                    className="btn btn-sm btn-outline"
                  >
                    <i className="fas fa-user"></i> ดูโปรไฟล์
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>ร่วมเป็นส่วนหนึ่งในการพัฒนาการศึกษาไทย</h2>
            <p>
              แบ่งปันความรู้ สื่อการสอน และนวัตกรรมของคุณ
              เพื่อสร้างสังคมแห่งการเรียนรู้ร่วมกัน
            </p>
            {!user ? (
              <Link to="/register" className="btn btn-lg btn-light">
                <i className="fas fa-user-plus"></i> สมัครสมาชิกวันนี้
              </Link>
            ) : (
              <Link to="/upload-resource" className="btn btn-lg btn-light">
                <i className="fas fa-upload"></i> เริ่มแบ่งปันตอนนี้
              </Link>
            )}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-section">
        <div className="container">
          <div className="section-header">
            <h2>วิธีการใช้งาน</h2>
            <p>ทำความรู้จักกับ TeacherShare ใน 4 ขั้นตอนง่ายๆ</p>
          </div>
          <div className="steps-container">
            <div className="step-card">
              <div className="step-number">1</div>
              <div className="step-icon">
                <i className="fas fa-user-plus"></i>
              </div>
              <h3>สมัครสมาชิก</h3>
              <p>ลงทะเบียนเข้าใช้งานระบบด้วยข้อมูลส่วนตัวของคุณอย่างง่ายดาย</p>
            </div>
            <div className="step-card">
              <div className="step-number">2</div>
              <div className="step-icon">
                <i className="fas fa-search"></i>
              </div>
              <h3>ค้นหาและเรียนรู้</h3>
              <p>
                ค้นหาสื่อการสอน นวัตกรรม และบทความที่ตรงกับความต้องการของคุณ
              </p>
            </div>
            <div className="step-card">
              <div className="step-number">3</div>
              <div className="step-icon">
                <i className="fas fa-upload"></i>
              </div>
              <h3>แบ่งปันผลงาน</h3>
              <p>
                แบ่งปันสื่อการสอน นวัตกรรม
                และบทความของคุณให้กับเพื่อนครูทั่วประเทศ
              </p>
            </div>
            <div className="step-card">
              <div className="step-number">4</div>
              <div className="step-icon">
                <i className="fas fa-trophy"></i>
              </div>
              <h3>รับรางวัลและการยอมรับ</h3>
              <p>รับเหรียญรางวัลและการยกย่องจากการแบ่งปันผลงานที่มีคุณภาพ</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="container">
          <div className="section-header">
            <h2>เสียงจากครูผู้ใช้งาน</h2>
            <p>ความประทับใจจากครูที่ใช้งานระบบ TeacherShare</p>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-content">
                <i className="fas fa-quote-left"></i>
                <p>
                  TeacherShare ช่วยให้ผมประหยัดเวลาในการเตรียมการสอนได้มาก
                  สื่อการสอนมีคุณภาพและสามารถนำไปปรับใช้ได้ทันที
                  ขอบคุณสำหรับแพลตฟอร์มดีๆ แบบนี้
                </p>
              </div>
              <div className="testimonial-author">
                <img
                  src="https://randomuser.me/api/portraits/men/32.jpg"
                  alt="ครูสมชาย"
                />
                <div className="testimonial-info">
                  <h3>ครูสมชาย วิชาการ</h3>
                  <p>ครูคณิตศาสตร์ ม.3</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <i className="fas fa-quote-left"></i>
                <p>
                  นวัตกรรมการสอนที่ได้จาก TeacherShare
                  ช่วยเปลี่ยนห้องเรียนของฉันไปอย่างสิ้นเชิง
                  นักเรียนมีความสนใจและมีส่วนร่วมในการเรียนมากขึ้น ขอบคุณมากค่ะ
                </p>
              </div>
              <div className="testimonial-author">
                <img
                  src="https://randomuser.me/api/portraits/women/65.jpg"
                  alt="ครูนภา"
                />
                <div className="testimonial-info">
                  <h3>ครูนภา ใจดี</h3>
                  <p>ครูภาษาไทย ป.6</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <i className="fas fa-quote-left"></i>
                <p>
                  การแชร์ประสบการณ์และไอเดียกับเพื่อนครูทั่วประเทศทำให้ผมได้มุมมองใหม่ๆ
                  ในการสอน TeacherShare ไม่เพียงแต่เป็นแหล่งรวมสื่อ
                  แต่ยังเป็นชุมชนที่สร้างแรงบันดาลใจ
                </p>
              </div>
              <div className="testimonial-author">
                <img
                  src="https://randomuser.me/api/portraits/men/45.jpg"
                  alt="ครูวิทย์"
                />
                <div className="testimonial-info">
                  <h3>ครูวิทย์ นวัตกร</h3>
                  <p>ครูวิทยาศาสตร์ ม.5</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
